module.exports = __webpack_public_path__ + "static/media/cancel.4632b11b.svg";